import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import useModalClickOutside from "utils/useModalClickOutside";
import { TYPO } from "styles/Typo";
import Button from "components/common/buttons/buttons";
import { useModalClose } from "lib/analytics/react/modal";

function ForbidOrderTimeModal({
  setModalOpen,
  isModalOpen,
}: {
  isModalOpen: boolean | any;
  setModalOpen: any;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { trackClose } = useModalClose();
  const selectChip = (orderCategory: string) => {
    switch (orderCategory) {
      case "none-ko-holiday":
        return "국내 휴장일";
      case "none-ko-reserve":
        return "예약주문 시스템 점검 중";
      case "none-ko-end":
        return "주문 시스템 점검 중";
      case "none-us-holiday":
        return "미국 휴장일";
      case "none-us-day":
        return "데이마켓 일시 중단 ";
      case "none-us-pre":
        return "프리마켓 일시 중단";
      // case "none-us-after":
      //   return "애프터마켓 일시 중단";
      default:
        return "";
    }
  };

  const chip = selectChip(isModalOpen.type);
  const desc = isModalOpen?.desc || "";
  return (
    <BottomFloatingModal isOpen={isModalOpen as boolean} modalRef={modalRef}>
      <div className="flex flex-col gap-4 w-full py-4 justify-center items-center">
        <div className="px-6 py-2 flex flex-col gap-2 w-full items-center justify-center">
          <div
            className={`
                ${TYPO.TYPO8_MD} text-gray60 px-2 py-1 bg-gray10 rounded-[30px] w-fit
            `}
          >
            {chip}
          </div>
          <span className={`${TYPO.TYPO4_SB} text-gray90`}>
            지금은 주문할 수 없어요
          </span>
          <span className={`${TYPO.TYPO7_RG} text-gray60`}>{desc}</span>
        </div>
        <div className="px-6 w-full ">
          <Button
            type="tertiary"
            text="확인"
            size="lg"
            width="w-full"
            clickHandler={() => {
              setModalOpen(false);
              trackClose("success");
            }}
          />
        </div>
      </div>
    </BottomFloatingModal>
  );
}

export default ForbidOrderTimeModal;
